import { c as _c } from "react/compiler-runtime";
import { useLocation } from 'react-router-dom';
import usePDPLayoutRevampTestVariant, { PDP_LAYOUT_REVAMP_VARIANTS } from './usePDPLayoutRevampTestVariant';

// `?galleryRevamp=1` forces the redesign on any environment so design and QA can
// review it without waiting on a bucket assignment. `?galleryRevamp=0` forces
// the control back for the same reason.
const readPreviewOverride = search => {
  const value = new URLSearchParams(search).get('galleryRevamp');
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  return null;
};
const useIsGalleryRevampVariant = t0 => {
  const $ = _c(2);
  const isEligible = t0 === undefined ? true : t0;
  const {
    search
  } = useLocation();
  const variant = usePDPLayoutRevampTestVariant(isEligible);
  if (!isEligible) {
    return false;
  }
  let t1;
  if ($[0] !== search) {
    t1 = readPreviewOverride(search);
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const previewOverride = t1;
  if (previewOverride !== null) {
    return previewOverride;
  }
  return variant === PDP_LAYOUT_REVAMP_VARIANTS.TEST_B;
};
export default useIsGalleryRevampVariant;